<div *ngIf="mappedChartDatasetsReady">

    <div #canvasContainer class="canvas-container">

        <canvas baseChart
                [datasets]="mappedChartDatasets"
                [labels]="mappedChartAxisLabels"
                [legend]="false"
                [options]="chartOptions"
                [type]="chartType">
        </canvas>
    </div>

    <p-dialog [header]="tableTitle"
              [modal]="true"
              [(visible)]="tableDialogOpen"
              [style]="{ height: '90%', width: '90%' }">

        <table>
            <thead>
            <tr>

                <th></th>

                <ng-container *ngFor="let yLabel of chartData.yLabels">

                    <th>{{ yLabel }}</th>

                </ng-container>

            </tr>
            </thead>
            <tbody>
            <ng-container *ngFor="let xLabel of chartData.xLabels; let i = index">
                <tr>

                    <td>{{ xLabel }}</td>

                    <td *ngFor="let value of chartData.values[i]">{{ value }}</td>

                </tr>
            </ng-container>
            </tbody>
        </table>
    </p-dialog>

    <p-contextmenu [model]="canvasContextMenuItems"
                   [target]="canvasContainer"
                   [appendTo]="'body'"></p-contextmenu>

</div>
